import { format } from "date-fns";

import { DATE_FORMATS_FNS } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DMSv3SettingsDashboardQueryKeys } from "modules/DMSv3/Settings/queryKeys";
import { ApiInstance } from "utils/Api";

import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type CreateDmsDealerPayload = Omit<AddEditDealerFormPayload, "dealer_id" | "dms_id"> & {
  dealer_id: number;
  dms_id: number;
};

export const useCreateDmsDealerMutation = () =>
  useTypedMutation<CreateDmsDealerPayload, void>({
    mutationFn: async payload =>
      (
        await ApiInstance.post(
          `/config/dealer/create`,
          {
            ...payload,
            start_time: format(payload.start_time, DATE_FORMATS_FNS.hoursMinutesSeconds),
            end_time: format(payload.end_time, DATE_FORMATS_FNS.hoursMinutesSeconds),
            full_run_hour_interval: payload.full_run_hour_interval ? payload.full_run_hour_interval : null
          },
          ENV.dmsv3BaseURL
        )
      ).data,
    onSuccess: () => typedQueryClient.invalidateQueries(DMSv3SettingsDashboardQueryKeys.dealers)
  });
